<!--
 * @Description: 更新手机号
 * @Author:  wang.y
-->
<template>
  <Modal v-model="modelIndex" width="530" class="login-model" @on-cancel="close" @on-visible-change="clearForms" :footer-hide="true">
    <div class="container-wrapper">
      <img :src="static_img_url + 'pic/modal-bg2.png?v=' + $store.state.imgVersion" class="model-bg" />
      <div class="container-content">
        <div class="container-top">
          <div class="container-title reset-form-title">{{'更新手机号' | dealLanguage('Update phone number')}}</div>
          <Form ref="update-form" :model="updateMobileForm" :rules="ruleValidate">
            <FormItem prop="mobile">
              <div class="mobile-ipt">
                <Dropdown placement="bottom-start" @on-click="handleChangeNumber">
                  <div class="area-number ">
                    <span>+{{loginNumber.mobileAreaCode}} ({{loginNumber.countryName}})</span>
                    <i class="iconfont">&#xe669;</i>
                  </div>
                  <DropdownMenu slot="list">
                    <DropdownItem :name="item.id" v-for="item in appMobileAreaCodeDtos" :key="item.id">+{{item.mobileAreaCode}} ({{item.countryName}})</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <Input type="text" v-model="updateMobileForm.mobile" :placeholder="'请输入手机号' | dealLanguage('Please enter mobile phone number')" autocomplete="off"></Input>
              </div>
            </FormItem>
            <FormItem v-if="ncStatus">
              <div class="nc-cnt">
                <div id="nc"></div>
              </div>
            </FormItem>
            <FormItem prop="code">
              <Input type="text" v-model="updateMobileForm.code" :placeholder="'请填写验证码' | dealLanguage('Please fill in the verification code')" autocomplete="off"></Input>
              <Captcha
                ref="captcha"
                scene="vbdata_bidingmobile"
                :mobile="updateMobileForm.mobile"
                :mobileAreaCode="loginNumber.mobileAreaCode"
                v-if="modelIndex"
              ></Captcha>
            </FormItem>
          </Form>

        </div>
        <div class="container-bottom">
          <p class="tip">{{'未注册的手机号将自动创建动脉网账号' | dealLanguage('Unregistered mobile phone numbers will automatically create an VBEF account')}}</p>
          <Button class="submit-btn" type="primary" @click="updateMobile">{{'保存' | dealLanguage('Save')}}</Button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Aaccountbinding } from '@/service/app'
import { loginCommon } from '@/assets/js/login'
import { mapState } from 'vuex'
import filter from 'js/filter'
import Captcha from '@/components/common/captcha'
export default {
  mixins: [loginCommon],
  inject: ['reload'],
  components: { Captcha },
  data() {
    return {
      modelIndex: false,
      loginWay: 'update-form',
      updateMobileForm: {
        mobile: '',
        code: '',
      },
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      language: (state) => state.language,
    }),
  },
  methods: {
    close() {
      this.modelIndex = false
    },
    clearForms(value) {
      if (value) return
      this.$refs['update-form'].resetFields()
      this.loginNumber = {
        ...{
          id: 1,
          mobileAreaCode: '86',
          countryName: '中国',
        },
      }
      this.codeStatus = 0
      this.wait = 60
      clearInterval(this.waitInterval)
    },
    updateMobile() {
      this.$refs['update-form'].validate(async (valid) => {
        if (valid) {
          let user = { ...this.$store.state.user }
          let res = await Aaccountbinding({
            code: this.updateMobileForm.code,
            mobile: this.updateMobileForm.mobile,
            mobileAreaCode: this.loginNumber.mobileAreaCode,
            type: 4,
            loginPlatform: 6,
            xuser: user,
          })
          if (res.code == 0) {
            user.mobile = this.updateMobileForm.mobile
            user.mobileAreaCode = this.loginNumber.mobileAreaCode
            this.$store.commit('updateUser', user)
            this.$Message.success(this.language == 'zh' ? '更新成功！' : ' Update successful!')
            this.$emit('updateMobileSuccess', user)
            this.modelIndex = false
          } else {
            this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        }
      })
    },
    handleChangeNumber(value) {
      let item = this.appMobileAreaCodeDtos.find((a) => a.id == value)
      this.loginNumber = { ...item }

      // this.updateRuleValidate()
    },
  },
  created() {
    // this.updateRuleValidate()
  },
  mounted() {},
}
</script>

<style lang="stylus" scoped>
@import '~styles/login.styl'
</style>
